import { hasSpellCheckErrors } from '../utils';
import { showSpellCheckSuggestions } from '../popup';

/**
 * Handle click on fix spelling control
 * @param {Event} eventData
 * @param {object} transform
 * @returns {boolean}
 */
export function handleFixSpellingClick(eventData, transform) {
  const textbox = transform.target;

  if (!hasSpellCheckErrors(textbox)) {
    return false;
  }

  // Prevent default behavior - especially important during editing
  if (eventData) {
    eventData.preventDefault && eventData.preventDefault();
    eventData.stopPropagation && eventData.stopPropagation();
  }

  // If textbox is in editing mode, we need to handle it specially
  if (textbox.isEditing) {
    // Exit editing mode first to ensure proper event handling
    textbox.exitEditing();

    // Re-select the textbox to maintain selection
    if (textbox.canvas) {
      textbox.canvas.setActiveObject(textbox);
    }
  }

  // Show suggestions popup
  showSpellCheckSuggestions(textbox, eventData);

  return true;
}
